import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import PlanRow from './row';

export function CommissionPlansTable({ plans, showArchivedPlans }) {
  const displayedPlans = plans.filter(plan => !plan.archived);
  
  if (showArchivedPlans) {
    displayedPlans.push(...plans.filter(plan => plan.archived));
  }
  
  return (
    <div className="table-container">
      <table className="table table-sticky text-nowrap">
        <thead>
          <tr>
            <th>Plan Name</th>
            <th>Plan Type</th>
            <th className="start-date-cell">Reset Date</th>
            <th className="reset-period-cell">Reset Period</th>
            <th className="next-period-cell">Next Period Starts</th>
            <th className="tiers-cell">Tiers</th>
            <th>Assigned To</th>
            <th className="sticky-cell end-cell" style={{ width: 0 }} />
          </tr>
        </thead>
        <tbody>
          {displayedPlans.map(plan => (
            <PlanRow key={plan.id} plan={plan} />
          ))}
        </tbody>
      </table>
    </div>
  );
}

CommissionPlansTable.propTypes = {
  plans: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
  })).isRequired,
  showArchivedPlans: PropTypes.bool,
};

const mapStateToProps = state => ({
  showArchivedPlans: state.settings.showArchivedPlans,
  plans: state.plans,
});

export default connect(mapStateToProps)(CommissionPlansTable);
